import { NgModule } from '@angular/core';
import { ToSymptomNumberPipe } from './to-symptom-number.pipe';

@NgModule({
  declarations: [ToSymptomNumberPipe],
  exports: [ToSymptomNumberPipe],
})
export class ToSymptomNumberModule {}
